
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../../../../services/profile.service';
import { users } from '../../../../../interfaces/users';

import { OrdersService } from '../../../../../services/orders';
import { WarehouseTypeService } from '../../../../../services/warehouse-type';
@Component({
  selector: 'app-warehouseinvoice',
  templateUrl: './warehouseinvoice.component.html',
  styleUrl: './warehouseinvoice.component.scss'
})
export class WarehouseinvoiceComponent {
  order_id!: any;
  userData!: users;
  data!: any;
  invoiceId!: any;
  userid!: any;
  date!: any;
  pagename!: any;
  userimage!: any;
  userphone!: any;
  facebook!: any;
  instagram!: any;
  tiktok!: any;
  note!: any;
  clientname!: any;
  firstphone!: any;
  delivery_hero!: any;
  secphone!: any;
  address!: any;
  products!: any;
  qty!: any;
  prices!: any;
  deliveryfees!: any;
  discount!: any;
  sumprices!: any;
  contentReady: boolean = true;
  qrPath!: any;
  link!: any;
  translateList: any = [];
  is_from_client: any;
  grov: any;
  city: any;
  receipt: any;
  warehouse_id: any;
  bonuses: any;
  website: any;
  @Input() orderid!: any;
  constructor(
    private _profileService: ProfileService,
    private _orderService: OrdersService,
    private _warehouseTypeService: WarehouseTypeService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.contentReady = true;
    if (this.orderid) {
      this.getOrderById(this.orderid);
      return;
    }
    this.route.queryParams.subscribe(params => {
      this.order_id = params['id'];

      // 🔥 شغّل الكود بعد 200ms (أو أي وقت انت عايزه)
      setTimeout(() => {
        this.getOrderById(this.order_id);

      }, 200); // 0.2 ثانية
    });

  }
  getOrderById(orderId: any) {


    this._orderService.getOrderById(orderId).subscribe({
      next: (res) => {
        this.data = res;
        if (this.data.note !== "undefined") {
          this.note = this.data.note;
        }
        else {
          this.note = "لا يوجد ملاحظات";
        }

        this.invoiceId = this.data.id;
        this.date = this.convertDate(this.data.created_at);
        this.clientname = this.data.client_name;
        this.warehouse_id = this.data.warehouse_id;
        this.firstphone = this.data.phone_number;
        this.secphone = this.data.another_phone;
        this.address = this.data.address;
        this.userid = this.data.user_id;
        this.is_from_client = this.data.is_from_client;
        this.deliveryfees = parseInt(this.data.delivery_fees);
        this.qty = String(this.data.quantity).split(",");
        this.prices = String(this.data.price).split(",");
        this.products = String(this.data.item).split(",");
        if (this.data.bonuses != null)
          this.bonuses = String(this.data.bonuses).split(",");
        if (this.data.delivery_hero != null)
          this.delivery_hero = this.data.delivery_hero;
        this.discount = isNaN(parseInt(this.data.discount)) ? 0 : parseInt(this.data.discount)
        this.sumprices = this.sumArray(this.prices);
        this.grov = this.data.governorate;
        this.city = this.data.city;
        this.getUserItems();
        this.getInvoiceQr();

      },
      error: (err) => alert("error"),
    });

  }

  sumArray(array: any[]): number {
    let fixedArray = [];
    for (let i = 0; i < array.length; i++) {
      fixedArray.push(parseInt(this.prices[i]) * parseInt(this.qty[i]));
    }
    return fixedArray.reduce((sum: number, value: number) => sum + value, 0);
  }
  convertDate(dateString: any) {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);  // Add leading zero if needed
    const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Month is 0-indexed, add 1
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  getUserItems() {

    this._warehouseTypeService.getWarehouseType(this.warehouse_id).subscribe({
      next: (res) => {
        this.pagename = this._warehouseTypeService.isAr
          ? res.warehouse.name
          : res.warehouse.name_en;
        this.website = this.removeHttps(res.warehouse.website);
        this.facebook = this.removeHttps(res.warehouse.facebook_link);
        this.instagram = this.removeHttps(res.warehouse.instagram_link);
        this.tiktok = this.removeHttps(res.warehouse.tiktok_link);
        this.userphone = res.warehouse.phone;

        if (
          res.warehouse.image_url == null ||
          res.warehouse.image_url == '' ||
          res.warehouse.image_url == 'undefined'
        ) {
          this.userimage = 'assets/logo-01.png';
        } else {
          this.userimage = this.changeUrl(res.warehouse.image);
        }

        this.contentReady = false;
      },
      error: (err) => {
        alert("error");
      },
    });

  }
  changeUrl(path: string): string {
    if (!path) return 'assets/logo-01.png';

    // لو اللينك كامل بالفعل سيبه زي ما هو
    if (path.startsWith('http')) return path;

    return `https://backendproduction.blueboxpet.com/storage/app/public/${path}`;
  }
  removeHttps(url: any) {
    if (url != null) {
      if (url.startsWith('https://')) {
        return url.substring(8);
      }
      return url;
    }
  }
  createList(e: any) {
    this.translateList.push(String(e));
    console.log(this.translateList)
  }
  fixImageUrl(image: string) {
    if (!image) return '';
    const fileName = image.split('/').pop();
    return "https://backendproduction.blueboxpet.com/storage/app/public/qrcodes/links/" + fileName;
  }
  getInvoiceQr(id: any = this.invoiceId) {
    this._orderService.getQrByOrderId(id).subscribe({
      next: (data: any) => {

        this.qrPath = data['qr_path'];
        this.link = data['link'];
      },
      error: (error) => {
        console.error("Error fetching QR:", error);
      }
    });
  }
  enableCardPrintAndPrint() {
    this.receipt = true;

    setTimeout(() => {
      window.print();
      this.receipt = false;
    }, 100);
  }

}
